import { MaterialDesignFrameworkModule } from '@ajsf/material';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgAutomationsModule } from '@principle-theorem/ng-automations';
import { NgClinicalChartingModule } from '@principle-theorem/ng-clinical-charting';
import { NgFeatureFlagsModule } from '@principle-theorem/ng-feature-flags';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import {
  NgPrincipleModule,
  RecallSettingsSummaryComponent,
} from '@principle-theorem/ng-principle';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { DepositConfigurationFormComponent } from '../practices/patient-portal/deposit-settings-form/deposit-configuration-form/deposit-configuration-form.component';
import { DepositSettingsFormComponent } from '../practices/patient-portal/deposit-settings-form/deposit-settings-form.component';
import { AccountModule } from './account/account.module';
import { EditManualTransactionTypeDialogComponent } from './accounting/edit-manual-transaction-type-dialog/edit-manual-transaction-type-dialog.component';
import { PaymentMethodAvailabilityComponent } from './accounting/payment-method-availability/payment-method-availability.component';
import { BrandAutomationsComponent } from './brand-automations/brand-automations.component';
import { BrandAppointmentTagsComponent } from './brand-tags/brand-appointment-tags/brand-appointment-tags.component';
import { BrandTagsComponent } from './brand-tags/brand-tags.component';
import { CalendarEventTagsComponent } from './brand-tags/calendar-event-tags/calendar-event-tags.component';
import { ContactTagsComponent } from './brand-tags/contact-tags/contact-tags.component';
import { PatientNoteTagsComponent } from './brand-tags/patient-note-tags/patient-note-tags.component';
import { PatientTagsComponent } from './brand-tags/patient-tags/patient-tags.component';
import { BrandTreatmentTemplatesComponent } from './brand-treatment-templates/brand-treatment-templates.component';
import { StafferTreatmentTemplateSelectComponent } from './brand-treatment-templates/staffer-treatment-template-select/staffer-treatment-template-select.component';
import { StafferTreatmentTemplateSelectStore } from './brand-treatment-templates/staffer-treatment-template-select/staffer-treatment-template-select.store';
import { TreatmentTemplateComponent } from './brand-treatment-templates/treatment-template/treatment-template.component';
import { UpsertTreatmentTemplateComponent } from './brand-treatment-templates/upsert-treatment-template/upsert-treatment-template.component';
import { UpsertTreatmentTemplateStore } from './brand-treatment-templates/upsert-treatment-template/upsert-treatment-template.store';
import { CancellationReasonsComponent } from './cancellation-reasons/cancellation-reasons.component';
import { SchedulingEventReasonStore } from './cancellation-reasons/cancellation-reasons.store';
import { EditCancellationReasonDialogComponent } from './cancellation-reasons/edit-cancellation-reason-dialog/edit-cancellation-reason-dialog.component';
import { SchedulingEventReasonService } from './cancellation-reasons/scheduling-event-reason.service';
import { DepositSettingsComponent } from './deposit-settings/deposit-settings.component';
import { GeneralBrandComponent } from './general-brand/general-brand.component';
import { TrackingCodeHelpModule } from './general-brand/tracking-code-help/tracking-code-help.module';
import { TrackingCodesComponent } from './general-brand/tracking-codes/tracking-codes.component';
import { MedicalHistoryModule } from './medical-history/medical-history.module';
import { PracticesModule } from './practices/practices.module';
import { ProductsModule } from './products/products.module';
import { ReferralEmailDefaultsPracticeComponent } from './referral-email-defaults/referral-email-defaults-practice/referral-email-defaults-practice.component';
import { ReferralEmailDefaultsComponent } from './referral-email-defaults/referral-email-defaults.component';
import { EditReferralSourceDialogComponent } from './referral-sources/edit-referral-source-dialog/edit-referral-source-dialog.component';
import { ReferralSourcesComponent } from './referral-sources/referral-sources.component';
import { ReferralSourcesStore } from './referral-sources/referral-sources.store';
import { StaffModule } from './staff/staff.module';
import { TeamsModule } from './teams/teams.module';
import { TemplatingModule } from './templating/templating.module';
import { EditTreatmentCategoryComponent } from './treatment-categories/edit-treatment-category/edit-treatment-category.component';
import { TreatmentCategoriesListComponent } from './treatment-categories/treatment-categories-list/treatment-categories-list.component';

@NgModule({
  declarations: [
    GeneralBrandComponent,
    DepositSettingsComponent,
    TreatmentTemplateComponent,
    UpsertTreatmentTemplateComponent,
    BrandTreatmentTemplatesComponent,
    CalendarEventTagsComponent,
    BrandAppointmentTagsComponent,
    PatientTagsComponent,
    StafferTreatmentTemplateSelectComponent,
    BrandTagsComponent,
    BrandAutomationsComponent,
    TreatmentCategoriesListComponent,
    EditTreatmentCategoryComponent,
    EditManualTransactionTypeDialogComponent,
    ReferralSourcesComponent,
    EditReferralSourceDialogComponent,
    EditCancellationReasonDialogComponent,
    CancellationReasonsComponent,
    ContactTagsComponent,
    PatientNoteTagsComponent,
  ],
  imports: [
    CommonModule,
    NgPrincipleModule,
    RouterModule,
    NgSharedModule,
    NgMaterialModule,
    NgClinicalChartingModule,
    AccountModule,
    ReactiveFormsModule,
    TemplatingModule,
    TeamsModule,
    StaffModule,
    ProductsModule,
    PracticesModule,
    NgFeatureFlagsModule,
    NgPrincipleSharedModule,
    NgAutomationsModule,
    MaterialDesignFrameworkModule,
    MedicalHistoryModule,
    TrackingCodeHelpModule,
    TrackingCodesComponent,
    RecallSettingsSummaryComponent,
    ReferralEmailDefaultsComponent,
    ReferralEmailDefaultsPracticeComponent,
    PaymentMethodAvailabilityComponent,
    DepositSettingsFormComponent,
    DepositConfigurationFormComponent,
  ],
  providers: [
    UpsertTreatmentTemplateStore,
    ReferralSourcesStore,
    SchedulingEventReasonStore,
    StafferTreatmentTemplateSelectStore,
    SchedulingEventReasonService,
  ],
})
export class BrandsModule {}
